module.exports = __webpack_public_path__ + "static/media/dashboard.d06a147b.svg";